import React from 'react';

import { FingerDownImage } from '../basic/FingerDownImage/FingerDownImage';

import './ContentPermanentHint.scss';

interface IContentPermanentHintProps {
  hideImage?: boolean;
}

export function ContentPermanentHint({ hideImage }: IContentPermanentHintProps) {
  return (
    <div className='ContentPermanentHint'>
      
      <h3 className='ContentPermanentHint__title'>Remember!</h3>
      <p className='ContentPermanentHint__block'>
        Everything you post you won't be able to edit or delete.
      </p>
      <p className='ContentPermanentHint__block'>
        So, <u>pay attention</u> and <u>be brave</u>.
      </p>

      {
        hideImage
          ? null
          : <FingerDownImage />
      }
    </div>
  );
}
